import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import LogoArea, { HeaderText } from './Logo.style';

const Logo = ({ className, withLink, linkTo, title, src }) => {
  return (
    <LogoArea className={className}>
      {withLink ? (
        <a href={linkTo}>
          {src && <img src={src} alt="Logo" />}
          {title && <HeaderText><h3>{title}</h3></HeaderText>}
        </a>
      ) : (
          <Fragment>
            {src && <img src={src} alt="Logo" />}
            {title && <HeaderText><h3>{title}</h3></HeaderText>}
          </Fragment>
        )}
    </LogoArea>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  withLink: PropTypes.bool,
  src: PropTypes.string,
  title: PropTypes.string,
  linkTo: PropTypes.string,
};

export default Logo;
